export const FacilitiesController = {
    index(): void {},
};
